import { createContext, PropsWithChildren, useEffect, useState } from 'react';

import { Photo, Series } from '@types';

export const DataContext = createContext({
  loaded: false,
  photos: [] as Photo[],
  series: [] as Series[],
});

export const DataProvider = ({ children }: PropsWithChildren) => {
  const [photos, setPhotos] = useState<Photo[]>();
  const [series, setSeries] = useState<Series[]>();

  const loaded = !!photos && !!series;

  useEffect(() => {
    Promise.all([fetch('/data/photos.json'), fetch('/data/series.json')]).then(
      async (data) => {
        const photosData: Photo[] = await data[0].json();
        const seriesData: Series[] = await data[1].json();

        setPhotos(photosData);
        setSeries(seriesData);
      },
    );
  }, []);

  return (
    <DataContext.Provider value={{ loaded, photos, series }}>
      {children}
    </DataContext.Provider>
  );
};
